import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { showLoader, hideLoader } from "../redux/features/globalLoaderSlice";
import { getPromotionStatus } from "../services/student_promotion";
import { toast } from "react-toastify";

const POLL_INTERVAL = 3000;

export default function usePromotionPolling({ onComplete } = {}) {
  const dispatch = useDispatch();
  const intervalRef = useRef(null);
  const hadActiveJobRef = useRef(false);

  useEffect(() => {
    return () => stopPolling();
  }, []);

  const stopPolling = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = null;
    hadActiveJobRef.current = false;
    dispatch(hideLoader());
  };

    const startPolling = async (jobId) => {
    if (intervalRef.current) return;

    const shouldContinue = await checkStatus(jobId);
    if (!shouldContinue) return;

    intervalRef.current = setInterval(() => {
      checkStatus(jobId);
    }, POLL_INTERVAL);
  };

  const checkStatus = async (jobId) => {
    try {
      const res = jobId
        ? await getPromotionStatus({ jobId })
        : await getPromotionStatus();
      const data = res?.data?.data;

      if (!data?.jobs?.length || data?.totalActiveJobs === 0) {
        if (hadActiveJobRef.current) onComplete?.();
        stopPolling();
        return false;
      }

      const job = data?.jobs[0];

      if (["PROCESSING", "PENDING"].includes(job?.jobStatus)) {
        if (!jobId) hadActiveJobRef.current = true;
        dispatch(showLoader("Student promotion in progress..."));
        return true;
      }

      if (job?.jobStatus === "COMPLETED") {
        toast.success("Students promoted successfully!");
        onComplete?.();
        stopPolling();
        return false;
      }

      if (job?.jobStatus === "FAILED") {
        toast.error("Promotion failed.");
        stopPolling();
        return false;
      }
      return false;
    } catch {
      stopPolling();
      toast.error("Error checking promotion status.");
      return false;
    }
  };

  return { startPolling, stopPolling  };
}
